"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import IconButton from "../../buttons/IconButton/IconButton.js";
import Paper from "../../layout/Paper/Paper.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import Heading from "../../typography/Heading/Heading.js";
import Html from "../../typography/Html/Html.js";
import { Spoiler } from "@mantine/core";
import { forwardRef } from "react";
import '../../../assets/FactBox.css';const root = "_root_1tci5_2";
const heading = "_heading_1tci5_16";
const content = "_content_1tci5_21";
const control = "_control_1tci5_25";
const FactBoxStyles = {
  root,
  heading,
  content,
  control
};
const _FactBox = forwardRef((props, ref) => {
  const { header, text, className, ...rest } = props;
  return /* @__PURE__ */ jsxs(Paper, { ...rest, className: `${FactBoxStyles.root} ${className}`, ref, p: 0, children: [
    /* @__PURE__ */ jsx(Heading, { type: "h3", text: header, className: FactBoxStyles.heading, variant: "light", p: "md" }),
    /* @__PURE__ */ jsx(
      Spoiler,
      {
        showLabel: /* @__PURE__ */ jsx(IconButton, { icon: "Plus", size: "md" }),
        hideLabel: /* @__PURE__ */ jsx(IconButton, { icon: "Minus", size: "md" }),
        classNames: FactBoxStyles,
        px: "lg",
        pt: "md",
        pb: 0,
        children: /* @__PURE__ */ jsx(Html, { html: text })
      }
    )
  ] });
});
_FactBox.displayName = "FactBox";
const FactBox = sharedHandler(_FactBox);
FactBox.displayName = _FactBox.displayName;
export {
  FactBoxStyles as F,
  FactBox as default
};
